import { useState } from "react";
import api from "../lib/api";
import { CAL_CATEGORIES } from "../lib/constants";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "sonner";
import { Trash2, Lock, Plus, Check } from "lucide-react";

function Row({ c, onChanged }) {
  const [name, setName] = useState(c.name);
  const [color, setColor] = useState(c.color);
  const [ask, setAsk] = useState(false);
  const dirty = name !== c.name || color !== c.color;
  const save = async () => { try { await api.put(`/calendar-categories/${c.id}`, { name, color }); toast.success("Categoria aggiornata"); onChanged(); } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); } };
  const del = async () => { try { await api.delete(`/calendar-categories/${c.id}`); toast.success("Categoria eliminata"); onChanged(); } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); } };
  return (
    <div className="flex items-center gap-2" data-testid={`cat-row-${c.id}`}>
      <input type="color" value={color} onChange={(e) => setColor(e.target.value)} data-testid={`cat-color-${c.id}`} className="w-9 h-9 rounded cursor-pointer border border-border p-0.5 bg-white shrink-0" />
      <Input value={name} onChange={(e) => setName(e.target.value)} data-testid={`cat-name-${c.id}`} className="h-9" />
      {dirty && <Button size="icon" className="h-9 w-9 shrink-0 bg-emerald-600 hover:bg-emerald-700 text-white" data-testid={`cat-save-${c.id}`} onClick={save}><Check size={15} /></Button>}
      {ask ? <Button size="sm" variant="destructive" className="shrink-0" data-testid={`cat-del-confirm-${c.id}`} onClick={del}>Elimina</Button>
        : <Button size="icon" variant="outline" className="h-9 w-9 shrink-0 text-destructive" data-testid={`cat-del-${c.id}`} onClick={() => setAsk(true)}><Trash2 size={15} /></Button>}
    </div>
  );
}

export default function CategoryManager({ open, onClose, categories, onChanged }) {
  const [name, setName] = useState("");
  const [color, setColor] = useState("#8B5CF6");
  const add = async () => {
    if (!name.trim()) return toast.error("Scrivi il nome della categoria");
    try { await api.post("/calendar-categories", { name, color }); toast.success("Categoria creata"); setName(""); onChanged(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="category-manager">
        <DialogHeader><DialogTitle className="font-head">Categorie del calendario</DialogTitle><DialogDescription>Le 4 categorie base restano fisse; puoi aggiungerne altre con il colore che vuoi.</DialogDescription></DialogHeader>
        <div className="space-y-2">
          {CAL_CATEGORIES.map((c) => (
            <div key={c.key} className="flex items-center gap-2 text-sm text-muted-foreground"><span className="w-9 h-9 rounded shrink-0" style={{ background: c.color }} /><span className="flex-1">{c.label}</span><Lock size={14} /></div>
          ))}
          {categories.map((c) => <Row key={c.id + c.name + c.color} c={c} onChanged={onChanged} />)}
        </div>
        <div className="border-t border-border pt-3 flex items-center gap-2">
          <input type="color" value={color} onChange={(e) => setColor(e.target.value)} data-testid="cat-new-color" className="w-9 h-9 rounded cursor-pointer border border-border p-0.5 bg-white shrink-0" />
          <Input placeholder="Nuova categoria, es. Assistenza" value={name} onChange={(e) => setName(e.target.value)} data-testid="cat-new-name" className="h-9" />
          <Button className="bg-brand hover:bg-[#A8472F] text-white shrink-0" data-testid="cat-add" onClick={add}><Plus size={15} className="mr-1" /> Aggiungi</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
